import { render, staticRenderFns } from "./origin.vue?vue&type=template&id=ac36adb4&scoped=true"
import script from "./origin.vue?vue&type=script&lang=js"
export * from "./origin.vue?vue&type=script&lang=js"
import style0 from "./origin.vue?vue&type=style&index=0&id=ac36adb4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac36adb4",
  null
  
)

export default component.exports